export enum TIntegrationRunTypes {
	importNow = "import_now",
	generateFile = "generate_file"
}